export default function CapabilitiesSection() {
  const capabilities = [
    {
      image: 'https://readdy.ai/api/search-image?query=Abstract%20system%20architecture%20visualization%20with%20layered%20geometric%20planes%2C%20clean%20lines%20and%20structured%20forms%2C%20deep%20teal%20background%20with%20warm%20coral%20accent%20highlights%2C%20modern%20engineering%20aesthetic%2C%20soft%20gradient%20atmosphere%2C%20translucent%20overlapping%20shapes%2C%20no%20text%20no%20people%20no%20devices%2C%20minimal%20abstract%20composition&width=440&height=587&seq=capability-01&orientation=portrait',
      alt: 'Abstract representation of scalable system architecture',
      title: 'Scalable Architecture',
      description: 'Designing maintainable systems with clean separation of concerns, modular component design, and future-proof structural foundations.',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Abstract%20performance%20optimization%20visualization%2C%20flowing%20light%20trails%20through%20geometric%20structure%2C%20smooth%20gradients%20in%20warm%20coral%20and%20teal%20tones%2C%20representing%20speed%20and%20efficiency%2C%20dark%20atmospheric%20background%2C%20minimal%20abstract%20render%2C%20no%20text%20no%20people%20no%20devices%2C%20clean%20motion%20aesthetic&width=440&height=587&seq=capability-02&orientation=portrait',
      alt: 'Abstract representation of high-performance engineering',
      title: 'Performance Engineering',
      description: 'Optimizing every layer of the software stack for responsiveness, efficiency, and seamless operation at scale.',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Abstract%20quality%20and%20precision%20visualization%2C%20intricate%20geometric%20patterns%20with%20sharp%20clean%20edges%2C%20warm%20coral%20and%20deep%20teal%20color%20palette%2C%20precision%20engineering%20aesthetic%2C%20macro%20detail%20of%20crystalline%20structures%2C%20dark%20atmospheric%20background%2C%20no%20text%20no%20people%20no%20devices%2C%20minimal%20refined%20composition&width=440&height=587&seq=capability-03&orientation=portrait',
      alt: 'Abstract representation of technical quality and precision',
      title: 'Technical Quality',
      description: 'Applying rigorous testing, code review, and quality assurance practices to deliver reliable, production-grade software.',
    },
  ];

  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="mb-14 md:mb-18">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground-950 leading-[1.2] tracking-tight">
            Core Engineering <span className="text-accent-500" aria-hidden="true">&#9670;</span> Capabilities
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-5">
          {capabilities.map((cap, i) => (
            <div key={i} className={`relative rounded-lg overflow-hidden group ${i === 0 ? 'md:col-span-1' : ''}`} style={{ aspectRatio: '3/4' }}>
              <img
                src={cap.image}
                alt={cap.alt}
                title={cap.alt}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/85 via-foreground-900/30 to-transparent" />
              <div className="absolute bottom-0 left-0 p-6 z-10">
                <h3 className="font-heading text-xl md:text-2xl font-semibold text-background-50 mb-2">
                  {cap.title}
                </h3>
                <p className="text-sm md:text-base text-background-200 leading-relaxed max-w-[320px]">
                  {cap.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}